import React from 'react';
import { FileText, Download, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';

const Reports = () => {
  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Reports & Exports
        </h1>
        <p className="text-slate-600 mt-1">Generate compliance-ready reports for inspections</p>
      </div>

      <div className="grid gap-4">
        {/* Daily Reports */}
        <div className="bg-white rounded-xl border border-slate-100 p-6 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <FileText className="w-6 h-6 text-primary" />
                <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  Daily Logs Report
                </h2>
              </div>
              <p className="text-slate-600 mb-4">
                Export daily activity logs for a specific child or classroom
              </p>
              <Button className="rounded-full" data-testid="export-daily-logs-button">
                <Download className="w-4 h-4 mr-2" />
                Generate Report
              </Button>
            </div>
          </div>
        </div>

        {/* Incident Reports */}
        <div className="bg-white rounded-xl border border-slate-100 p-6 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <FileText className="w-6 h-6 text-rose-600" />
                <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  Incident Reports
                </h2>
              </div>
              <p className="text-slate-600 mb-4">
                Export all incident, injury, and illness reports for compliance
              </p>
              <Button className="rounded-full" data-testid="export-incidents-button">
                <Download className="w-4 h-4 mr-2" />
                Generate Report
              </Button>
            </div>
          </div>
        </div>

        {/* Health Checks */}
        <div className="bg-white rounded-xl border border-slate-100 p-6 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <Calendar className="w-6 h-6 text-green-600" />
                <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  Health Check Records
                </h2>
              </div>
              <p className="text-slate-600 mb-4">
                Export daily health observation and temperature records
              </p>
              <Button className="rounded-full" data-testid="export-health-checks-button">
                <Download className="w-4 h-4 mr-2" />
                Generate Report
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
        <h3 className="font-semibold text-blue-900 mb-2">Report Generation</h3>
        <p className="text-sm text-blue-800">
          All reports are generated in PDF format and are ready for Texas CCR inspections. Reports include proper timestamps, audit trails, and all required documentation.
        </p>
      </div>
    </div>
  );
};

export default Reports;
